import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Loading from 'components/LoadingComponent';
import Countdown from 'components/Countdown';
import Avatar from 'components/Avatar';
import misteryIcon from 'assets/images/speed_dating/mistery.svg';
import {
  getSpeedDatingData, joinSpeedDatingRandom, deleteSpeedDatingRandom,
} from 'modules/speedDating/actions';
import {
  LoadingWrapper, MainScreen, AvatarWrapper,
} from './styles';

function SpeedDatingRandomMeeting(props) {
  const {
    app, literals, setBreadcrumb, resetAll, history,
    match: { params: { id: paramId } },
  } = props;
  const id = parseInt(paramId, 10);

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasFinishCountdown, setHasFinishCountdown] = useState(false);

  const loadSpeedDatingData = () => {
    getSpeedDatingData(id)
      .then((response) => {
        setData(response);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const createBreadcrumb = () => {
    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.title,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetAll();
  };

  const finishCountdown = () => {
    setHasFinishCountdown(true);
  };

  const backToSpeedDating = () => {
    history.push(`/speed-dating/${id}`);
  };

  useEffect(() => {
    createBreadcrumb();
    loadSpeedDatingData();
  }, [id]);

  useEffect(() => {
    if (data && data.start_date <= moment().unix()) {
      joinSpeedDatingRandom(id);
    }

    return (() => {
      if (data && data.start_date <= moment().unix()) {
        deleteSpeedDatingRandom(id);
      }
    });
  }, [data, hasFinishCountdown]);

  if (isLoading) {
    return (<LoadingWrapper><Loading colorAnimation={app.color1} /></LoadingWrapper>);
  }

  const printMainScreen = () => {
    return (
      <MainScreen color={app.color1}>
        <div className='content'>
          <div className='title'>{literals.randomMeetingInProcess}</div>
          <img src={misteryIcon} alt='' />
          <div>
            <button className='primary' onClick={backToSpeedDating}>{literals.backToSpeedDating}</button>
          </div>
        </div>
      </MainScreen>
    );
  };

  const printCountDown = () => {
    return (
      <MainScreen color={app.color1}>
        <div className='content'>
          <div className='title'>{literals.randomMeetingNotStarted}</div>
          <Countdown time={data.start_date} onFinish={finishCountdown} enabled />
          <img src={misteryIcon} alt='' />
          <div>
            <button className='primary' onClick={backToSpeedDating}>{literals.backToSpeedDating}</button>
          </div>
        </div>
      </MainScreen>
    );
  };

  if (isLoading) {
    return (<LoadingWrapper><Loading colorAnimation={app.color1} /></LoadingWrapper>);
  }

  if (data.start_date > moment().unix()) {
    return printCountDown();
  }

  return (
    <div>
      {printMainScreen()}
    </div>
  );
}

SpeedDatingRandomMeeting.propTypes = {
  match: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  resetAll: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default SpeedDatingRandomMeeting;



// WEBPACK FOOTER //
// ./src/routes/SpeedDatingRandomMeeting/components/index.jsx